import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteQuestion } from "src/modules/question/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteQuestion, id } = props;

    const handleDelete = async () => {
        try {
            await deleteQuestion(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteQuestion)(DeleteView);
